import { Button, Grid, Spinner } from '@chakra-ui/react'
import type { InsuranceParamsPropertyDto } from 'BrokerTsLib/src/dtos'
import { Product, Risk, SelectionType } from 'BrokerTsLib/src/enums'
import { toDate } from 'BrokerTsLib/src/Utils/formatPrice'
import { format } from 'date-fns'
import { useState } from 'react'

import { DatepickerPopup } from '@/components/DatepickerPopup'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useOffersContext } from '@/context/useOffersContext'
import { useWizzardHeader } from '@/context/WizzardHeaderContext'
import { useGetRiskVariants, useSelections } from '@/hooks'
import { useUpdateInsuranceStartDate } from '@/hooks/useWizard'

import { useApp } from '@/hooks/useApp'
import { InsuranceInfoFormControl } from './InsuranceInfoFormControl'

// import calendarIcon from '@/images/calendar-icon.svg'

export const InsuranceSettingsFormProperty = () => {
  const { product } = useApp()
  const { data: propertyTypesData } = useGetRiskVariants(Risk.PROPERTY_TYPE)
  const { data: realtyTypesData } = useSelections(SelectionType.TypNemovitosti)

  const { isScrolled } = useWizzardHeader()
  const { insuranceParams: ip, insuranceParamsId, refetchInsuranceParams, isDisabled } = useInsuranceParams()
  const insuranceParams = ip as InsuranceParamsPropertyDto
  const { mutateAsync: updateInsuranceStartDate } = useUpdateInsuranceStartDate(insuranceParamsId!)
  const { recalculateOffers: recalculate, offers } = useOffersContext()

  const startDate = insuranceParams!.generalParams.insuranceStartDate

  const now = new Date()

  const isDateInvalid = startDate
    ? new Date(startDate) <= toDate(now)!
    : true

  const [isSavingInsruanceStartDate, setIsSavingInsruanceStartDate] = useState(false)
  const handleSetStartDate = (date: Date) => {
    setIsSavingInsruanceStartDate(true)

    updateInsuranceStartDate(date)
      .then(() => {
        recalculate(offers.map(o => o.offerId), true)

        refetchInsuranceParams() // aby se updatnul header
      })
      .finally(() => setIsSavingInsruanceStartDate(false))
  }

  return (
    <>
      <Grid
        sx={{
          gap: isScrolled ? 0 : 1,
          gridAutoFlow: 'column',
          gridTemplateColumns: 'repeat(3, 1fr)',
        }}
      >
        <InsuranceInfoFormControl
          label="Počátek pojištění"
          value={startDate && format(new Date(startDate), 'd. M. yyyy')}
          hasError={!isDisabled && isDateInvalid}
          errorMessage={!isDisabled && isDateInvalid ? 'Datum nesmí být v minulosti' : null}
          leftControl={
            <>
              {!isDisabled &&
                <Button variant="unstyled" size="sm">
                  {!isSavingInsruanceStartDate &&
                    <DatepickerPopup
                      date={now}
                      onDateChange={(date: Date) => handleSetStartDate(date)}
                      dateMin={new Date(now.toDateString())}
                      iconProps={{
                        color: isDateInvalid ? 'red.500' : 'insurance-info-value-color'
                      }}
                    />}
                  {isSavingInsruanceStartDate && <Spinner color={isDateInvalid ? 'red.500' : 'insurance-info-value-color'} />}
                </Button>
              }
            </>
          }
        />

        {product == Product.PropertyInsurance &&
          <>
            <InsuranceInfoFormControl
              label="Typ pojištění"
              value={propertyTypesData?.data.find(x => x.id == insuranceParams.property.type)?.name}
            />

            <InsuranceInfoFormControl
              label="Typ nemovitosti"
              value={realtyTypesData?.data.find(x => x.id == insuranceParams.property.data.realtyTypeId)?.description}
            />
          </>
        }
      </Grid>
    </>
  )
}
